import constants from 'constants/index'

const formStatusLabel = (status) => {
  return (
    (status &&
      constants.consent.CONSENT_FORM_STATUS_LABEL_TRANSLATION[status]) ||
    'Indefinido'
  )
}

export default formStatusLabel
